"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var models_1 = require("./models");
var BarScaleCalculator_1 = require("../../charting/BarScale/BarScaleCalculator");
var Query = ksys_app_template_1.query.Query;
var TableLogicBase = /** @class */ (function () {
    function TableLogicBase(props, globalConfiguration, translationHelper) {
        var _this = this;
        this.props = props;
        this.globalConfiguration = globalConfiguration;
        this.translationHelper = translationHelper;
        this.formatValueForColumn = function (value, column, translationContext) {
            var _a = (_this.globalConfiguration || {}).formats, globalFormats = _a === void 0 ? {} : _a;
            var _b = _this.props.formatsByType, formatsByType = _b === void 0 ? {} : _b;
            var formatType = column.formatType, format = column.format;
            var workingFormat = format || (formatType && (formatsByType[formatType] || globalFormats[formatType]));
            if (workingFormat) {
                if (!workingFormat.locale) {
                    workingFormat.locale = translationContext && translationContext.culture;
                }
                if (!workingFormat.options) {
                    workingFormat.options = {};
                }
                return ksys_app_template_1.utils.formatter.formatter(workingFormat, value);
            }
            return value;
        };
        this.getCellSuperscripts = function (column, row) {
            var id = column.id;
            var _superscriptsByColumnId = row._superscriptsByColumnId;
            if (_superscriptsByColumnId && _superscriptsByColumnId[id]) {
                return _superscriptsByColumnId[id].sort(function (a, b) {
                    return a === b ? 0 : a > b ? 1 : -1;
                });
            }
            return undefined;
        };
        this.getHeadCellSuperscripts = function (column) {
            var _headerSuperscripts = column._headerSuperscripts;
            if (_headerSuperscripts) {
                return _headerSuperscripts;
            }
            return undefined;
        };
        this.getExpanderColumn = function (hasChildren) {
            var response = {
                id: '_expander',
                key: '_expander',
                hide: false,
                excludeFromNoDataCheck: true,
                placeholder: ' ',
            };
            if (hasChildren) {
                response.display = {
                    type: models_1.TableColumnDisplayType.expander,
                    options: {
                        expander: {},
                    },
                };
            }
            return response;
        };
        this.getHeaderRowCount = function (columns, headerGroupsById) {
            var max = 1;
            for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
                var column = columns_1[_i];
                var headerGroupId = column.headerGroupId;
                var headerGroup = !!headerGroupId && headerGroupsById[headerGroupId];
                if (headerGroup) {
                    var groupNesting = _this.getGroupNesting(headerGroup, headerGroupsById);
                    max = Math.max(max, groupNesting);
                }
            }
            return max;
        };
        this.getGroupNesting = function (headerGroup, headerGroupsById, seed) {
            if (seed === void 0) { seed = 1; }
            seed++;
            var parentId = headerGroup.parentId;
            var parentHeaderGroup = !!parentId && headerGroupsById[parentId];
            if (parentHeaderGroup) {
                return _this.getGroupNesting(parentHeaderGroup, headerGroupsById, seed);
            }
            return seed;
        };
        this.loadGroupInHeadRows = function (group, headRows, headerGroupsById) {
            var index = 0;
            var parentGroupId = group.parentId;
            var parentGroup = !!parentGroupId && headerGroupsById[parentGroupId];
            if (parentGroup) {
                index = _this.loadGroupInHeadRows(parentGroup, headRows, headerGroupsById) + 1;
            }
            var row = headRows && headRows.length > index && headRows[index];
            if (row) {
                var existing = row.find(function (mapping) { return mapping.group && mapping.group.id === group.id; });
                if (existing) {
                    existing.colSpan++;
                }
                else {
                    row.push({
                        group: group,
                        colSpan: 1,
                        rowSpan: 1,
                        hasChildren: true,
                    });
                }
            }
            return index;
        };
        if (props.rows && props.columns) {
            var barScaleCol_1 = props.columns.find(function (col) { return col.display && col.display.type === models_1.TableColumnDisplayType.barScale; });
            if (barScaleCol_1 && barScaleCol_1.display && barScaleCol_1.display.options && barScaleCol_1.display.options.barScale) {
                var baseOptions = barScaleCol_1.display.options.barScale.baseOptions;
                this.BarScaleCalculator = new BarScaleCalculator_1.BarScaleCalculator(props.rows, function (row) { return _this.getRawValue(row, barScaleCol_1); }, baseOptions);
            }
        }
    }
    TableLogicBase.prototype.getRawValue = function (row, column) {
        var key = column.key, keyQuery = column.keyQuery;
        var value = ksys_app_template_1.utils.get(row, key);
        if (keyQuery) {
            var query_1 = new Query(keyQuery);
            value = query_1.execute({ responseContext: row }) || value;
        }
        if (value === undefined && this.translationHelper) {
            var translatedKey = this.translationHelper.translate(key);
            value = ksys_app_template_1.utils.get(row, translatedKey);
        }
        return value;
    };
    Object.defineProperty(TableLogicBase.prototype, "emptyColumnIds", {
        get: function () {
            var response = [];
            var _a = this.props, columns = _a.columns, rows = _a.rows;
            if (columns && rows) {
                for (var _i = 0, _b = columns.filter(function (column) { return !column.hide; }); _i < _b.length; _i++) {
                    var column = _b[_i];
                    var columnHasData = false;
                    for (var _c = 0, rows_1 = rows; _c < rows_1.length; _c++) {
                        var row = rows_1[_c];
                        var value = this.getRawValue(row, column);
                        if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(value)) {
                            columnHasData = true;
                            break;
                        }
                    }
                    if (!columnHasData) {
                        response.push(column.id);
                    }
                }
            }
            return response;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableLogicBase.prototype, "visibleColumns", {
        get: function () {
            var _a = this.props, columns = _a.columns, excludeEmptyColumns = _a.excludeEmptyColumns;
            var emptyColumnIds = this.emptyColumnIds;
            return (columns || []).filter(function (column) {
                var id = column.id, hide = column.hide;
                return !hide && (!excludeEmptyColumns || !emptyColumnIds.includes(id));
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableLogicBase.prototype, "headerColumns", {
        get: function () {
            var columns = __spreadArrays(this.visibleColumns);
            if (this.props && this.props.grouping) {
                var _a = this.props.grouping.alignExpander, alignExpander = _a === void 0 ? 'left' : _a;
                if (alignExpander === 'left') {
                    columns.unshift(this.getExpanderColumn(false));
                }
                else {
                    columns.push(this.getExpanderColumn(false));
                }
            }
            return columns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableLogicBase.prototype, "defaultHeaderGroup", {
        get: function () {
            return {
                id: '_defaultHeaderGroup',
                header: '',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableLogicBase.prototype, "headerMapping", {
        get: function () {
            var headRows = [];
            var columns = this.headerColumns;
            var headerGroups = this.props.headerGroups;
            var headerGroupsById = ksys_app_template_1.utils.collection.pivotCollection(headerGroups || [], function (value) { return value.id; });
            var headerRowCount = this.getHeaderRowCount(columns, headerGroupsById);
            for (var counter = 0; counter < headerRowCount; counter++) {
                headRows.push([]);
            }
            for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
                var column = columns[columnIndex];
                var headerGroupId = column.headerGroupId;
                var headerGroup = !!headerGroupId && headerGroupsById[headerGroupId];
                if (!headerGroup) {
                    headRows[0].push({
                        column: column,
                        columnIndex: columnIndex,
                        colSpan: 1,
                        rowSpan: 1,
                        hasChildren: false,
                    });
                }
                else {
                    var parentIndex = this.loadGroupInHeadRows(headerGroup, headRows, headerGroupsById);
                    var rowIndex = parentIndex + 1;
                    var row = headRows && headRows.length > rowIndex && headRows[rowIndex];
                    if (row) {
                        row.push({
                            column: column,
                            columnIndex: columnIndex,
                            colSpan: 1,
                            rowSpan: 1,
                            hasChildren: false,
                        });
                    }
                }
            }
            for (var index = 0; index < headRows.length; index++) {
                var row = headRows[index];
                var remainingRowCount = headRows.length - index;
                for (var _i = 0, row_1 = row; _i < row_1.length; _i++) {
                    var mapping = row_1[_i];
                    if (!mapping.hasChildren) {
                        mapping.rowSpan = remainingRowCount;
                    }
                }
            }
            return headRows;
        },
        enumerable: true,
        configurable: true
    });
    TableLogicBase.prototype.getColumnDisplay = function (column) {
        var response = {
            type: models_1.TableColumnDisplayType.raw,
        };
        if (column.display) {
            response = column.display;
        }
        else if (column.contextMenuProps) {
            response = {
                type: models_1.TableColumnDisplayType.contextMenu,
                options: {
                    contextMenu: column.contextMenuProps,
                },
            };
        }
        else if (column.actionsProps) {
            response = {
                type: models_1.TableColumnDisplayType.actions,
                options: {
                    actions: column.actionsProps,
                },
            };
        }
        else if (column.checkboxProps) {
            response = {
                type: models_1.TableColumnDisplayType.checkbox,
                options: {
                    checkbox: column.checkboxProps,
                },
            };
        }
        else if (column.iconProps) {
            response = {
                type: models_1.TableColumnDisplayType.icon,
                options: {
                    icon: column.iconProps,
                },
            };
        }
        else if (column.changeIndicatorProps) {
            response = {
                type: models_1.TableColumnDisplayType.changeIndicator,
                options: {
                    changeIndicator: column.changeIndicatorProps,
                },
            };
        }
        if (!response.type || !response.options || !response.options[response.type]) {
            response = {
                type: models_1.TableColumnDisplayType.raw,
            };
        }
        return response;
    };
    TableLogicBase.getTooltipRowProps = function (row, column) {
        var response = [];
        if (column && Array.isArray(column.tooltips) && column.tooltips.length > 0) {
            var showMultipleTooltips = column.showMultipleTooltips;
            var tooltips = ksys_app_template_1.utils.collection.filterWithMatchingProperties(column.tooltips, { target: 'row' });
            if (tooltips) {
                for (var i = 0; i < tooltips.length; i++) {
                    var tooltip = tooltips[i];
                    if (tooltip) {
                        var shouldAddTooltip = true;
                        if (tooltip.conditional) {
                            var conditionalTooltipHelper = new ksys_app_template_1.helpers.ConditionalHelper(tooltip.conditional);
                            shouldAddTooltip = conditionalTooltipHelper.matches(row);
                        }
                        if (shouldAddTooltip) {
                            var target = tooltip.target, conditional = tooltip.conditional, tooltipProps = __rest(tooltip, ["target", "conditional"]);
                            response.push(tooltipProps);
                            if (!showMultipleTooltips) {
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (response && response.length > 0 && row._tooltipInputs) {
            for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
                var tooltipProps = response_1[_i];
                if (tooltipProps.content) {
                    tooltipProps.content = ksys_app_template_1.utils.replacePlaceholders({ values: row._tooltipInputs, text: tooltipProps.content });
                }
            }
        }
        return response;
    };
    return TableLogicBase;
}());
exports.TableLogicBase = TableLogicBase;
